import React, { useEffect } from 'react';

export const BooleanFilter: React.ComponentType<{
  onChange: (values: string[]) => void;
  value?: any[];
}> = ({ onChange, value = [] }) => {
  const [checked, setChecked] = React.useState(['0', '0']);

  useEffect(() => {
    setChecked((current) => {
      const newChecked = [...current];
      newChecked[0] = value[0];
      newChecked[1] = value[1];
      return newChecked;
    });
  }, []);

  const handleChange = (key: number) => {
    setChecked((current) => {
      const newChecked = [...current];
      newChecked[key] =
        current[key] === undefined ? '1' : current[key] === '1' ? '0' : '1';
      return newChecked;
    });

    const asd = [];
    asd[key] =
      checked[key] !== undefined ? (checked[key] === '1' ? '0' : '1') : '1';
    const siblingKey = key ? 0 : 1;
    if (checked[siblingKey] !== undefined) {
      asd[siblingKey] = checked[siblingKey];
    }

    onChange(asd);
  };

  return (
    <>
      <div className="flex gap-[10px] boolean-filter-box">

      </div>
    </>
  );
};
